/**
 * Prédicats sur la structure web_data d'un proposal.
 */

/**
 * Le web_data contient-il au moins une page ?
 * Sert à distinguer un proposal « site généré » d'un proposal vide/non généré.
 *
 * @param {{ pages?: Record<string, unknown> } | null | undefined} webData
 * @returns {boolean}
 */
export function webDataHasPages(webData) {
  const pages = webData?.pages;
  return !!(pages && Object.keys(pages).length > 0);
}
